import { render, staticRenderFns } from "./SingleGameLevelSettings.vue?vue&type=template&id=01dc2134&scoped=true&"
import script from "./SingleGameLevelSettings.vue?vue&type=script&lang=js&"
export * from "./SingleGameLevelSettings.vue?vue&type=script&lang=js&"
import style0 from "./SingleGameLevelSettings.vue?vue&type=style&index=0&id=01dc2134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc2134",
  null
  
)

export default component.exports